/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC } from "react";
import ArtistCard from "../cards/ArtistCard";
import TrackCard from "../cards/TrackCard";
import { connect } from "react-redux";
import { RootState } from "../../store/reducers";
import { Track } from "../../models/track";
import { User } from "../../models/user";

const Feed: FC<{
  list: Track[];
  users: User[];
}> = ({ list, users }) => {
  document.getElementsByTagName("title")[0].innerHTML = "feed";

  return (
    <div className="app-view">
      <div className="app-view-body">
        <div className="app-header">
          <h4>Feed</h4>
        </div>
        <div id="feed-list" uk-scrollspy="uk-aniamtion-slide-right">
          {list &&
            list.map((track, i) => {
              return <TrackCard key={i} track={track} />;
            })}
        </div>
      </div>
      <div className="app-view-extra ls">
        <div className="extras-body">
          <div>
            <div className="artist">
              <div
                className="artist-name"
                style={{ fontSize: "24px", marginBottom: "8px" }}
              >
                Featured
              </div>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {users &&
                users.map((user) => <ArtistCard user={user} key={user.id} />)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapState = (state: RootState) => ({
  list: state.data.list,
  users: state.data.users,
});

export default connect(mapState)(Feed);
